import React from 'react';
import ThemifyIconsContainer from '../../Componant/Icons/ThemifyIcon';

const ThemifyIcons = () => {
  return (
    <div className='page-body'>
      <ThemifyIconsContainer />
    </div>
  );
};

export default ThemifyIcons;
